export enum UserGroup {
  Internal = 'Intern',
  Admin = 'Admin',
  Client = 'Kunde'
}
